export const ACTIVATION_BEGIN = 'ACTIVATION_BEGIN';
export const ACTIVATION_CLEAR = 'ACTIVATION_CLEAR';
export const ACTIVATION_FAILURE = 'ACTIVATION_FAILURE';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';

export const LOGIN_BEGIN = 'LOGIN_BEGIN';
export const LOGIN_CLEAR = 'LOGIN_CLEAR';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export const PASSWORD_EMAIL_BEGIN = 'PASSWORD_EMAIL_BEGIN';
export const PASSWORD_EMAIL_CLEAR = 'PASSWORD_EMAIL_CLEAR';
export const PASSWORD_EMAIL_FAILURE = 'PASSWORD_EMAIL_FAILURE';
export const PASSWORD_EMAIL_SUCCESS = 'PASSWORD_EMAIL_SUCCESS';
export const PASSWORD_RESET_BEGIN = 'PASSWORD_RESET_BEGIN';
export const PASSWORD_RESET_CLEAR = 'PASSWORD_RESET_CLEAR';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';

export const REGISTRATION_BEGIN = 'REGISTRATION_BEGIN';
export const REGISTRATION_CLEAR = 'REGISTRATION_CLEAR';
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';

export const SET_TOKEN = 'SET_TOKEN';
export const SET_USERNAME = 'SET_USERNAME';

export const SET_LOGIN_DATA = 'SET_LOGIN_DATA';
export const REMOVE_LOGIN_DATA = 'REMOVE_LOGIN_DATA';

export const GET_PROFILE = 'GET_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const ERROR_PROFILE = 'ERROR_PROFILE';

export const CART_ADD_PRODUCT = 'CART_ADD_PRODUCT';
export const CART_REMOVE_PRODUCT = 'CART_REMOVE_PRODUCT';
export const EMPTY_CART = 'EMPTY_CART';

export const CHECKOUT_STEP_IDENTIFICATION = 'CHECKOUT_STEP_IDENTIFICATION';
export const CHECKOUT_STEP_MEDIATYPE = 'CHECKOUT_STEP_MEDIATYPE';
export const CHECKOUT_STEP_PAYMENT = 'CHECKOUT_STEP_PAYMENT';
export const CHECKOUT_STEP_COMPLETE = 'CHECKOUT_STEP_COMPLETE';

export const ORDER_PAYMENT_CREATE = 'ORDER_PAYMENT_CREATE';
export const ORDER_PAYMENT_CALLBACK = 'ORDER_PAYMENT_CALLBACK';
